// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/text-align-center.js';

import { paths } from '../generated/text-align-center';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('text-align-center', Original, paths);
